// @ngInject
function StockApiService(ResourcesService, $window, DSHttpAdapter, $q, DS) {

    var endpoint = 'stock';

    return {
        getProductStock: ResourcesService.apiFactory.get(endpoint + '/productstock'),
        getProducts: getProducts,
        getProduct: ResourcesService.apiFactory.get(endpoint + '/products'),
        getLocation: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getCompaniesBrief: ResourcesService.apiFactory.get(endpoint + '/companiesbrief'),
        getFilteredLocations: getFilteredLocations,
        getFilteredBrands: getFilteredBrands,
        getMainGroups: ResourcesService.apiFactory.get(endpoint + '/maingroups'),
        getInventoryTypes: ResourcesService.apiFactory.get(endpoint + '/inventorytypes'),
        getBrands: ResourcesService.apiFactory.get(endpoint + '/brands'),
        getCollections: ResourcesService.apiFactory.get(endpoint + '/collections'),
        getStockTransactionsForArticleAndLocation: ResourcesService.apiFactory.get(endpoint + '/stocktransactions'),
        saveProductInventory: ResourcesService.apiFactory.save(endpoint + '/productinventory'),
        downloadStockValueReport: downloadStockValueReport,
        downloadProductReport: downloadProductReport,
        downloadSoldStockReport: downloadSoldStockReport,
        downloadStockPickingList: downloadStockPickingList,
        downloadSaleThroughputReport: downloadSaleThroughputReport,
        downloadSaleThroughputReportPdf: downloadSaleThroughputReportPdf,
        getDepartments: ResourcesService.apiFactory.get(endpoint + '/departments')
    };

    function downloadStockPickingList(request) {
        var deferred = $q.defer();

        var params = {
            locationId: request.locationId,
            startDate: request.startDate,
            endDate: request.endDate,
            sortOrder1: request.sortOrder1,
            sortOrder2: request.sortOrder2,
            sortOrder3: request.sortOrder3,
            showCollection: request.showCollection,
            showDepartment: request.showDepartment,
            grouping: request.grouping,
            includeArticleNumber: request.includeArticleNumber,
            includeStorageItems: request.includeStorageItems,
            includeIsPhotographed: request.includeIsPhotographed,
            includeZeroAndNegativeQuantity: request.includeZeroAndNegativeQuantity,
            portraitOrientation: request.portraitOrientation,
            showRestOfLocations: request.showRestOfLocations
        };

        DSHttpAdapter.GET(DS.defaults.basePath + 'stock/pickinglist', { params: params, responseType: 'arraybuffer' }).then(function(response) {
            //If 204 the call returned no result/empty list don't return a downloadable file
            if (response && response.status === 204) {
                deferred.resolve(response);
                return deferred.promise;
            }

            //"attachment; filename=stockpickinglist20190110.pdf"
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'stockpickinglist.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadSaleThroughputReport(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/salethroughputreport', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'SaleThroughput.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadSaleThroughputReportPdf(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/salethroughputreportpdf', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'SaleThroughput.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProducts(page, filter, pageSize, companyId, showInactiveArticles, matchEntireSearchTerm) {

        var params = {
            filter: '',
            page: 1,
            pageSize: 20
        };

        if (page && page > 1) {
            params.page = page;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.filter = filter;
        }

        if (companyId) {
            params.companyId = companyId;
        }

        if (showInactiveArticles) {
            params.showInactiveArticles = showInactiveArticles;
        }

        if(matchEntireSearchTerm !== undefined) {
            params.matchEntireSearchTerm = matchEntireSearchTerm;
        }

        var args = { params: params };

        return ResourcesService.apiFactory.get(endpoint + '/products')(args);
    }

    function downloadProductReport(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/productreport', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'ProductReport.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadStockValueReport(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/stockvaluereport', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            //"attachment; filename=stockpickinglist20190110.pdf"
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'StockValueReport.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadSoldStockReport(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/soldStockReport', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            //"attachment; filename=stockpickinglist20190110.pdf"
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'SoldStockReport.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFilteredLocations() {
        var args = { params: {filterOnUser: true} };
        return ResourcesService.apiFactory.get(endpoint + '/locations')(args);
    }

    function getFilteredBrands() {
        var args = { params: {filterOnUser: true} };
        return ResourcesService.apiFactory.get(endpoint + '/brands')(args);
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=StockPickingList20190110.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([-\w\d\s]){1,}\.(pdf|csv|xls){1,}/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('stock.api', [])
    .factory('StockApiService', StockApiService);
